/**
 * These are machine-readable error codes for various error types in the
 * application.
 *
 * @remarks
 *
 * These codes are used in ApplicationErrors to provide a consistent way to
 * identify error types programmatically, and can be useful for debugging and
 * support as well as conditional error handling logic in clients.
 */
export const ERROR_CODES = {
  SNAP_UNKNOWN_ERROR: '0000',
  SNAP_IMPORT_ERROR: '0010',
  SNAP_IMPORT_CSV_PARSE_ERROR: '0011',
  SNAP_IMPORT_VALIDATION_ERROR: '0012',
  SNAP_IMPORT_EXCEL_PARSE_ERROR: '0013',
  SNAP_IMPORT_FILE_FORMAT_ERROR: '0014',
  SNAP_IMPORT_COLUMN_STRUCTURE_ERROR: '0015',
  SNAP_IMPORT_DATA_CONTENT_ERROR: '0016',
  SNAP_IMPORT_NO_COMPATIBLE_IMPORTER: '0017',
  SNAP_SEND_QUOTE_ERROR: '0018',
  SNAP_SEND_QUOTE_OVERSIZED_FILE_ERROR: '0019',
  SNAP_SEND_QUOTE_DUPLICATE_FILENAME_ERROR: '0020',
  SNAP_EDIT_QUOTE_NOT_EDITABLE: '0021',
  SNAP_SEND_QUOTE_VISUAL_IDENTIFIER_TOO_LONG: '0022',
  SNAP_SEND_QUOTE_VISUAL_DECIMAL_OUT_OF_RANGE: '0023',
  SNAP_QUOTE_LINE_LIMIT_EXCEEDED: '0024',

  SNAP_AUTO_CONFIGURATOR_CALCULATION_ERROR: '0100',
  SNAP_AUTO_CONFIGURATOR_MASTER_SHEET_MISMATCH_ERROR: '0101',

  POSTGRES_UNKNOWN_ERROR: '1000',
  POSTGRES_CONNECTION_ERROR: '1001',
  POSTGRES_NOT_FOUND_ERROR: '1002',
  POSTGRES_UNIQUE_CONSTRAINT_ERROR: '1003',
  POSTGRES_TIMEOUT_ERROR: '1004',
  POSTGRES_QUERY_ERROR: '1005',
  POSTGRES_FOREIGN_KEY_ERROR: '1006',
  POSTGRES_TRANSACTION_ERROR: '1007',
  POSTGRES_CHECK_CONSTRAINT_ERROR: '1008',

  VISUAL_UNKNOWN_ERROR: '2000',
  VISUAL_TIMEOUT_ERROR: '2001',

  AWS_UNKNOWN_ERROR: '3000',
  AWS_S3_UNKNOWN_ERROR: '3100',
  AWS_SES_UNKNOWN_ERROR: '3200',

  WORKFLOW_CONTEXT_ERROR: '4000',
  WORKFLOW_TRANSACTION_ERROR: '4001',
  WORKFLOW_COMPENSATION_ERROR: '4002',
  WORKFLOW_INVALID_ROLLBACK_ERROR: '4003',
} as const;

/**
 * These are somewhat arbitrary machine-readable IDs for external services. They
 * are chosen to "look like" error codes, so that users seeing them in error
 * messages can easily reference them when reporting issues.
 *
 * @TODO(shawk): move these to a shared location
 */
export const EXTERNAL_SERVICE_IDS = {
  POSTGRES: '12000',
  VISUAL: '22000',
  AWS: '32000',
} as const;
